<div class="login-content">
  <div class="login-card">
    <div class="img-agent prima-logo">
      <img src="assets/img/prima-logo.png">
    </div>
    <div class="img-agent prima-text">
      Registrace
    </div>
    <mat-card appearance="outlined">
      <mat-card-content>
        <form [formGroup]="emailForm">
          <mat-form-field class="inp-email">
            <mat-label>Zadejte email:</mat-label>
            <input formControlName="email" name="email" type="email" matInput (keyup.enter)="sendMail()">
          </mat-form-field>
          <ng-container [ngSwitch]="true">
            <button *ngSwitchCase="disableInputs && loading"
                    type="submit"
                    mat-flat-button
                    color="primary"
                    class="btn-email"
                    disabled>
              <mat-spinner [diameter]="20" color="primary"></mat-spinner>
            </button>

            <button *ngSwitchCase="disableInputs && !loading && !errorMsg"
                    type="submit"
                    mat-flat-button
                    color="primary"
                    class="btn-email"
                    disabled>
              <mat-icon>check</mat-icon>
              Odesláno na <strong>{{email}}</strong>
            </button>

            <button *ngSwitchCase="disableInputs && !loading && errorMsg"
                    type="submit"
                    mat-flat-button
                    color="primary"
                    class="btn-email"
                    disabled>
              <mat-icon>close</mat-icon>
              Chyba
            </button>

            <button *ngSwitchDefault
                    type="submit"
                    mat-flat-button
                    color="primary"
                    class="btn-email"
                    (click)="sendMail()"
                    [disabled]="!emailForm.valid">
              <mat-icon>mark_email_read</mat-icon>
              Odeslat přihlašovací odkaz
            </button>
          </ng-container>
        </form>
        @if (errorMsg) {
          <small style="color:red"><mat-icon slot="start">error</mat-icon> Registraci se nepodařilo dokončit z následujícího důvodu:<br><code>{{errorMsg}}</code></small>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
